import { render, staticRenderFns } from "./admin-tcr-campaigns.vue?vue&type=template&id=3747fff0&scoped=true&"
import script from "./admin-tcr-campaigns.vue?vue&type=script&lang=js&"
export * from "./admin-tcr-campaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3747fff0",
  null
  
)

export default component.exports